/* eslint-disable react-hooks/exhaustive-deps */
import { CSSProperties,  LegacyRef,  MouseEvent,  useEffect, useRef } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { getLandingContainer } from "../../utils/getLandingContainer"

/* Protopia Ecosystem component */
export interface IRotateHandlerProps {
   style: CSSProperties
}
const WidthHandler = (props: IRotateHandlerProps): JSX.Element => {
    const selectedLayer                                 = useLandingStore((state: ILandingStore) => state.selectedLayer)
    const ref: LegacyRef<HTMLDivElement> | undefined    = useRef(null)
    const isDrag                                        = useSyncState<boolean>(false)


    const onMouseDown = () => {
        isDrag.set( true )
    }
    const onMouseUp = () => {
        isDrag.set( false )
    }
    const onMove = (evt: any): void => {
        if( !isDrag || !ref.current ) {
            return
        }
        // console.log( evt.clientX, evt.clientY )
        (ref.current as any).style.left = evt.clientX - 25
        
    }
    useEffect(() => {
        const landing = getLandingContainer()
        landing.addEventListener("move", onMove)
        return () => landing.removeEventListener("move", onMove)
    }, [])

    return <div 
        className='scale-container-handler' 
        style={props.style}
        onMouseDown={ onMouseDown }
        onMouseUp={ onMouseUp }
        ref={ref}
    >
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width="30px"
            height="30px"
            viewBox="0 0 576 596.4" 
            xmlSpace="preserve"
        > 
            <g id="Layer_3">
                <circle className="st0" cx="293.6" cy="298.2" r="32.5"/>
                <path d="M257.2,298.2c0-19.9,16.1-36,36-36s36,16.1,36,36s-16.1,36-36,36S257.2,318.1,257.2,298.2z M322.6,298.2
                    c0-16.2-13.2-29.3-29.3-29.3c-16.2,0-29.3,13.2-29.3,29.3s13.2,29.3,29.3,29.3C309.4,327.5,322.6,314.4,322.6,298.2z"/>
            </g>
            <g id="Layer_2">
                <polygon className="st1" points="111,237.5 108.4,358.9 49,296.9 	"/>
                <polygon className="st1" points="465,358.9 467.6,237.5 527,299.5 	"/>
                <rect className="st1" x="420.2" y="262.7" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 739.9344 -143.5344)" width="43" height="71"/>
                <rect className="st1" x="111.2" y="262.7" transform="matrix(-1.836970e-16 1 -1 -1.836970e-16 430.9344 165.4656)" width="43" height="71"/>
            </g>
        </svg>
    </div>
}
export default WidthHandler